import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";
import { translateItem } from "../i18n/menuItemTrans";

export const MenuSection = ({ section, index = 0 }) => {
  const { t, lang } = useLang();
  const localizedName = t.sections[section.name] || section.name;
  const localizedDesc = section.desc ? translateItem(section.desc, lang) : null;

  return (
    <Reveal className="mb-16 sm:mb-24" delay={Math.min(index * 60, 240)}>
      <div className="flex items-baseline gap-4 mb-8">
        <span
          className="text-xs tracking-[0.3em] uppercase"
          style={{ color: "var(--color-text-muted)" }}
        >
          {String(index + 1).padStart(2, "0")}
        </span>
        <h2
          className="text-3xl sm:text-4xl md:text-5xl font-[\'Playfair_Display\'] font-medium"
          style={{ color: "var(--color-dark)" }}
        >
          {localizedName}
        </h2>
      </div>
      {localizedDesc && (
        <p className="italic mb-8 -mt-4 max-w-2xl" style={{ color: "var(--color-text-muted)" }}>
          {localizedDesc}
        </p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
        {section.items.map((item, i) => (
          <div
            key={i}
            data-testid={`menu-item-${index}-${i}`}
            className="group border-b border-[color:var(--color-dark)]/15 pb-5 last:border-b-0 transition-all"
          >
            <div className="flex items-start gap-3">
              <p
                className="font-[\'Playfair_Display\'] text-lg sm:text-xl leading-snug"
                style={{ color: "var(--color-dark)" }}
              >
                {translateItem(item.name, lang)}
              </p>
              <span
                className="flex-1 mt-3 border-b border-dotted opacity-40"
                style={{ borderColor: "var(--color-dark)" }}
              />
              {item.price && (
                <p
                  className="whitespace-nowrap font-[\'Playfair_Display\'] text-lg sm:text-xl"
                  style={{ color: "var(--color-accent)" }}
                >
                  {item.price}
                </p>
              )}
            </div>
            {item.desc && (
              <p
                className="mt-1 text-sm leading-relaxed max-w-xl"
                style={{ color: "var(--color-text-muted)" }}
              >
                {translateItem(item.desc, lang)}
              </p>
            )}
          </div>
        ))}
      </div>

      {section.footnote && (
        <p className="mt-8 text-xs italic max-w-3xl" style={{ color: "var(--color-text-muted)" }}>
          {section.footnote}
        </p>
      )}
    </Reveal>
  );
};
